import type { ReactElement } from 'react';
import { cn } from '@/lib/cn';

export type AdminStatTileTone = 'neutral' | 'warn' | 'ok';

export type AdminStatTileProps = {
  label: string;
  value: string;
  delta?: string;
  subLabel?: string;
  tone: AdminStatTileTone;
};

const TONE_CLASS: Readonly<Record<AdminStatTileTone, string>> = {
  neutral: '',
  warn: 'admin-stat-tile--warn border-[var(--warn)]',
  ok: 'admin-stat-tile--ok border-[var(--ok)]',
};

export function AdminStatTile({ label, value, delta, subLabel, tone }: AdminStatTileProps): ReactElement {
  return (
    <div
      className={cn(
        'rounded-[var(--r-md)] border border-[var(--rule)] bg-[var(--bg-surface)] p-4 flex flex-col gap-1',
        TONE_CLASS[tone],
      )}
    >
      <div className="text-[10px] font-mono uppercase tracking-[0.16em] text-[var(--ink-3)]">
        {label}
      </div>
      <div className="font-display text-[28px] font-semibold leading-none mt-1">{value}</div>
      {delta && <div className="text-[11px] text-[var(--ink-3)] mt-1">{delta}</div>}
      {subLabel && <div className="text-[11px] text-[var(--ink-4)] mt-0.5">{subLabel}</div>}
    </div>
  );
}
